import React from 'react';
import { Box, Typography, Stack, Paper, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { VideoCarousel } from './VideoCarouselModal';
import { VideoCarouselThumbnailStrip } from './VideoCarouselThumbnailStrip';

interface VideoCarouselCardProps {
  carousel: VideoCarousel;
  onEdit: (carousel: VideoCarousel) => void;
  onDelete: (carouselId: string) => void;
}

export function VideoCarouselCard({ carousel, onEdit, onDelete }: VideoCarouselCardProps) {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            {carousel.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {carousel.videos.length} videor
          </Typography>
          <VideoCarouselThumbnailStrip videos={carousel.videos} />
        </Box>
        <Stack direction="row" spacing={1}>
          <IconButton size="small" onClick={() => onEdit(carousel)} color="primary">
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => onDelete(carousel.id)} color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}
